import { IFormValidation } from '@aston/foundation';

export class IContactFormValidator implements IFormValidation {
	ruleset = 'sendContactEmailCommandValidator';
	fields = {
		Body: 'Body',
		CanRecall: 'CanRecall',
		Email: 'Email',
		FirstName: 'FirstName',
		LastName: 'LastName',
		PhoneNumber: 'PhoneNumber',
		RecallDate: 'RecallDate',
		RecallTime: 'RecallTime',
		Subject: 'Subject'
	};
}

export const ContactFormValidator = new IContactFormValidator();
